import React,{useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu,FiX,FiSearch,FiUser,FiShield}=FiIcons;

const Header=()=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);
  const location=useLocation();
  
  const navigation=[ 
    {name: 'Home',href: '/'},
    {name: 'Assessments',href: '/assessments'},
    {name: 'Dashboard',href: '/dashboard'},
    {name: 'Team',href: '/team'} 
  ];

  return ( 
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        <div className="flex justify-between items-center h-16"> 
          {/* Logo */} 
          <Link to="/" className="flex items-center space-x-2"> 
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center"> 
              <span className="text-white font-bold text-lg">BA</span> 
            </div> 
            <span className="text-xl font-bold text-gray-900 hidden sm:block">Business 360°</span> 
          </Link> 

          {/* Desktop Navigation */} 
          <nav className="hidden md:flex space-x-1 lg:space-x-4"> 
            {navigation.map((item)=> ( 
              <Link 
                key={item.name} 
                to={item.href} 
                className={`px-3 py-2 rounded-lg text-sm font-bold transition-all ${
                  location.pathname===item.href 
                    ? 'text-blue-600 bg-blue-50' 
                    : 'text-gray-500 hover:text-blue-600 hover:bg-gray-50'
                }`} 
              > 
                {item.name} 
              </Link> 
            ))} 
          </nav> 

          {/* Right side icons */} 
          <div className="flex items-center space-x-2"> 
            <Link to="/team" className={`p-2 rounded-lg transition-colors ${location.pathname === '/team' ? 'text-blue-600 bg-blue-50' : 'text-gray-400 hover:text-gray-600'}`}>
              <SafeIcon icon={FiShield} className="w-5 h-5" />
            </Link>
            <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors"> 
              <SafeIcon icon={FiUser} className="w-5 h-5" /> 
            </button> 
            
            {/* Mobile menu button */} 
            <button onClick={()=> setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-gray-400 hover:text-gray-600" > 
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" /> 
            </button> 
          </div> 
        </div> 

        {/* Mobile Navigation */} 
        {isMenuOpen && ( 
          <motion.div initial={{opacity: 0,height: 0}} animate={{opacity: 1,height: 'auto'}} exit={{opacity: 0,height: 0}} className="md:hidden border-t border-gray-200 py-4" > 
            <nav className="space-y-1"> 
              {navigation.map((item)=> ( 
                <Link 
                  key={item.name} 
                  to={item.href} 
                  onClick={()=> setIsMenuOpen(false)} 
                  className={`block px-3 py-2 rounded-lg text-base font-bold transition-all ${
                    location.pathname===item.href 
                      ? 'text-blue-600 bg-blue-50' 
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`} 
                > 
                  {item.name} 
                </Link> 
              ))} 
            </nav> 
          </motion.div> 
        )} 
      </div> 
    </header> 
  );
};

export default Header;